import React, { useState, useEffect } from "react";
import Anchor from "./components/Anchor";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { Alert, Button, Image } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Section from "./components/Section";
import MediaPlayer from "./components/MediaPlayer";
import { longDateFormat } from "./utils/dates";

const Blog = () => {
  let { slug } = useParams();
  const [post, setPost] = useState();
  const [displayError, setDisplayError] = useState(false);
  const [postImage, setPostImage] = useState(
    "https://source.unsplash.com/featured/?technology&ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000&fit=max&ixid=eyJhcHBfaWQiOjExNzczfQ"
  );

  useEffect(() => {
    async function fetchPost() {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_API_URL}/ghost/posts/slug/${slug}`
        );
        setPost(result.data.posts[0]);
        if (result.data.posts[0].feature_image)
          setPostImage(result.data.posts[0].feature_image);
      } catch (error) {
        console.log(error);
        setDisplayError(true);
      }
    }
    fetchPost();
  }, [slug]);

  const customPostFields =
    post && post.codeinjection_head
      ? JSON.parse(post.codeinjection_head)
      : null;
  return (
    <React.Fragment>
      <Helmet>
        <title>
          Aspiricity - {`${(post && post.title) || "Tech Nomad Blog"}`}
        </title>
      </Helmet>
      <Header>
        <h1>The Tech Nomad Blog</h1>
      </Header>
      <Section bgColor="bg-light" textColor="text-dark">
        {!post &&
          !displayError &&
          "Loading article content..."}
        {post && (
          <React.Fragment>
            <div className="p-4">
              <h1>{post.title}</h1>
              <br />
              <p className="lead">{post.excerpt}</p>
              <hr />
              <p>
                {longDateFormat(new Date(post.published_at).toDateString())} |{" "}
                {post.reading_time} min read
              </p>
            </div>
            {customPostFields && customPostFields.mediaOnly ? (
              <MediaPlayer url={customPostFields.mediaURL} />
            ) : (
              <Image src={postImage} alt={post.title} fluid />
            )}
            <br />
            <br />
            <div
              className="ghost-text p-4"
              dangerouslySetInnerHTML={{ __html: post.html }}
            ></div>
            {customPostFields && !customPostFields.mediaOnly && (
              <React.Fragment>
                <MediaPlayer url={customPostFields.mediaURL} />
                <br />
                <hr />
              </React.Fragment>
            )}
            <p className="p-3 text-center">
              <Button as={Anchor} variant="primary" to="/blog">
                Back to the Tech Nomad Blog
              </Button>
            </p>
          </React.Fragment>
        )}
        {displayError && (
          <Alert
            variant="danger"
            onClose={() => setDisplayError(false)}
            dismissible
          >
            We're having trouble loading the latest blog content right now. Please try again shortly, or return to the <Anchor to={"/"}>Aspiricity home page</Anchor>.
          </Alert>
        )}
      </Section>
      <Footer />
    </React.Fragment>
  );
};

export default Blog;
